"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import gql from "graphql-tag";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";
import type { AccommodationForm } from "./useCreateAccommodationForm";

interface DeleteAccommodationFormMutationVariables {
  id: string;
}

export const deleteAccommodationFormMutation = gql`
  mutation deleteAccommodationForm($id: ID!) {
    deleteAccommodationForm(id: $id) {
      id
      patientId
      episodeOfCareId
      status
      formData
      createdAt
      updatedAt
      submittedAt
      signedAt
      createdBy
    }
  }
`.loc?.source.body as GeneratedMutation<
  DeleteAccommodationFormMutationVariables,
  {
    deleteAccommodationForm: AccommodationForm;
  }
>;

export const useDeleteAccommodationForm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: DeleteAccommodationFormMutationVariables) =>
      fetchGraphQLClient(deleteAccommodationFormMutation, variables),
    onSuccess: (data) => {
      const form = data.data?.deleteAccommodationForm;
      if (form) {
        queryClient.invalidateQueries({
          queryKey: ["accommodationForms", form.patientId],
        });
        queryClient.invalidateQueries({
          queryKey: ["accommodationFormsByEpisode", form.episodeOfCareId],
        });
        queryClient.removeQueries({
          queryKey: ["accommodationForm", form.id],
        });
      }
    },
  });
};
